import {
  LineOfCreditSubmitApplicationInput,
  LineOfCreditSubmitApplicationUnion,
  Mutation,
} from '@varo/graphql-schema-types';
import LineOfCreditSubmitApplication from 'services/graphql/mutations/LineOfCreditSubmitApplication';
import { CombinedError, useMutation } from 'urql';

interface LineOfCreditSubmitApplicationResult {
  result?: LineOfCreditSubmitApplicationUnion;
  error?: CombinedError;
  fetching: boolean;
  triggerMutation: (
    idempotencyId: string,
    input: LineOfCreditSubmitApplicationInput,
  ) => void;
}

const useLineOfCreditSubmitApplication =
  (): LineOfCreditSubmitApplicationResult => {
    const [{ data, fetching, error }, executeMutation] = useMutation<Mutation>(
      LineOfCreditSubmitApplication,
    );

    const triggerMutation = (
      idempotencyId: string,
      input: LineOfCreditSubmitApplicationInput,
    ) => {
      void executeMutation({
        idempotencyId,
        input,
      });
    };

    return {
      result: data?.lineOfCreditSubmitApplication,
      fetching,
      error,
      triggerMutation,
    };
  };

export default useLineOfCreditSubmitApplication;
